import React, { useEffect, useState } from "react";
import { MdOutlineFilterAlt } from "react-icons/md";
import { debounce } from "lodash";
import Dropdown from "../Common/Dropdown";
import { Table } from "../Common/Table/Table";
import moment from "moment/moment";

const TransactionHistory = ({ customerData }) => {
  const [filteredData, setFilteredData] = useState(customerData || []);
  const [filterStatus, setFilterStatus] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const option = [
    { value: "", name: "All" },
    { value: "SUCCESS", name: "Successfully" },
    { value: "PENDING", name: "Pending" },
    { value: "FAILED", name: "Failed" },
  ];

  const columns = [
    {
      header: "Transaction ID",
      accessor: "paymentId",
    },
    {
      header: "Shop Name",
      accessor: "shopName",
      customTxt: (data) => {
        const shopName = data?.merchant?.businessDetils?.shopName || "N/A";
        return <span>{shopName}</span>;
      },
    },
    {
      header: "Date",
      accessor: "date",
      customTxt: (data) => {
        const date = moment(data.date).format("L");
        return <span>{date}</span>;
      },
    },
    {
      header: "Time",
      accessor: "time",
      customTxt: (data) => {
        const time = moment(data.date).format("LT");
        return <span>{time}</span>;
      },
    },
    {
      header: "Transaction",
      accessor: "transaction",
      customTxt: (data) => {
        const transaction = data?.reward_points || "N/A";
        return <span>{transaction}</span>;
      },
    },
    {
      header: "Location",
      accessor: "",
      customTxt: (data) => {
        const location = data?.merchant?.businessDetils?.businessAddress || "N/A";
        return <span>{location}</span>;
      },
    },
    {
      header: "Status",
      accessor: "",
      customTxt: (data) => {
        const status = data.status || "N/A";
        const color =
          status === "FAILED"
            ? "#F07403"
            : status === "SUCCESS"
            ? "#1F9254"
            : "#CD6200";

        const bgColor =
          status === "FAILED"
            ? "#FFF4E5"
            : status === "SUCCESS"
            ? "#E5F7ED"
            : "#FDF0E3";

        return (
          <span
            style={{
              color,
              backgroundColor: bgColor,
              borderRadius: "0.8rem",
              padding: "0.5rem",
              display: "inline-block",
              textAlign: "center",
              width: "100px",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {status}
          </span>
        );
      },
    },
  ];


  const handleSearch = debounce((query) => {
    setSearchQuery(query.toLowerCase());
  }, 300);

  useEffect(() => {
    let data = customerData;

    if (filterStatus) {
      data = data.filter((item) => item.status === filterStatus);
    }

    if (searchQuery) {
      data = data.filter((item) => {
        const shopName = item?.merchant?.businessDetils?.shopName?.toLowerCase() || "";
        const location = item?.merchant?.businessDetils?.businessAddress?.toLowerCase() || "";
        const transactionId = item?.paymentId?.toLowerCase() || "";
        const date = moment(item.date).format("L").toLowerCase();
        const time = moment(item.date).format("LT").toLowerCase();

        return (
          shopName.includes(searchQuery) ||
          location.includes(searchQuery) ||
          transactionId.includes(searchQuery) ||
          date.includes(searchQuery) ||
          time.includes(searchQuery)
        );
      });
    }

    setFilteredData(data);
  }, [filterStatus, searchQuery, customerData]);

  return (
    <div className="p-4">
      <div className="w-full flex justify-between items-center pe-5 py-5">
        {/* Search Input */}
        <div className="flex items-center w-1/2">
          <input
            type="text"
            placeholder="Search by shop name, transaction ID, date, or time"
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>
        <div className="w-full flex justify-end items-center pe-5 py-5">
          <div className="w-42 h-auto flex justify-between items-center border-[1px] bg-[#025D89] rounded-lg py-1 px-2">
            <MdOutlineFilterAlt className="text-white" />
            <Dropdown
              option={option}
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              SelectClass="bg-[#025D89] text-white outline-none"
            />
          </div>
        </div>
      </div>
      <div>
        <Table columns={columns} data={filteredData} tableClass="h-[430px]" />
      </div>
    </div>
  );
};

export default TransactionHistory;

